<h2 mat-dialog-title>Send documents</h2>

<mat-dialog-content class="send-document-dialog">
    <p class="send-document-intro">
        Choose what to send to <strong>{{ patientName }}</strong>.
    </p>

    <!--
        WHAT ACTUALLY HAPPENS (practice-documents.md 19, 21.2).

        There is no per-document link any more. A document the patient has to send back rides an
        INVITE containing exactly these documents and nothing else - the same rail practice forms
        and consent requests already use - so the patient opens one link and returns everything
        through it. Anything that is only for them to keep still goes as an email attachment with
        no link at all (14), which is what the picker's own sentence above describes.
    -->
    <p class="send-document-what-happens" data-test="send-what-happens">
        <mat-icon>info</mat-icon>
        <span>
            Anything you tick that has to come back is sent as an invite containing those
            documents and returned under the inbox menu. {{ patientName }} opens the one link and sends them back through it — the
            same link keeps working, so if you add another document later you can just resend it.
        </span>
    </p>

    <!--
      §14.3 - the shared picker. It loads the practice's documents, says what each one asks of the
      patient, and says what the whole selection will do. This dialog owns the channels and the 409,
      and nothing about an individual document.

      Since wave 1 it is a CHIP ROW plus an attach button, and the tickable list is a dialog over
      this one. This host has the strongest claim on an inline list - choosing documents is the
      whole purpose of this screen - and it deliberately does not get an exception: see the picker's
      class header. What it gets back is its own subject matter, the channels and the physician and
      the 409, no longer pushed below a scrolling list.
    -->
    <app-document-attachment-picker context="manual" [patientId]="patient?.id"
        [groupId]="patientGroupId" [selection]="selectedDocumentIds"
        label="Documents to send"
        (selectionChange)="onSelectionChange($event)"
        (selectedDocumentsChange)="onSelectedDocumentsChange($event)">
    </app-document-attachment-picker>

    <ng-container *ngIf="form">
        <form [formGroup]="form" novalidate>

            <mat-form-field appearance="outline" class="full-width m-t-10" *ngIf="groupUsers.length">
                <mat-label>Physician (optional)</mat-label>
                <mat-select formControlName="physicianId">
                    <mat-option [value]="''">No specific physician</mat-option>
                    <mat-option *ngFor="let user of groupUsers" [value]="user.userId">
                        {{ user.title }} {{ user.name }} {{ user.surname }}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <div class="send-document-channels">
                <div class="send-document-channels-label">Send by</div>

                <mat-checkbox formControlName="email" [disabled]="!hasEmail">
                    Email
                    <span class="send-document-channel-note" *ngIf="!hasEmail">
                        — no email address on file
                    </span>
                </mat-checkbox>

                <mat-checkbox formControlName="sms" [disabled]="!hasMobile">
                    SMS / WhatsApp
                    <span class="send-document-channel-note" *ngIf="!hasMobile">
                        — no mobile number on file
                    </span>
                </mat-checkbox>
            </div>
        </form>
    </ng-container>

    <!--
        A dedupe refusal. NOT a red error: nothing went wrong, the patient simply already has this
        document or is not due it yet. See the component header.
    -->
    <div class="send-document-blocked" *ngIf="blockedMessage" data-test="send-blocked">
        <mat-icon>info</mat-icon>
        <div>
            <div class="send-document-blocked-message">{{ blockedMessage }}</div>
            <button mat-button color="primary" type="button" *ngIf="blockedRequestId"
                (click)="openBlockingRequest()">
                Show that request
            </button>
        </div>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button type="button" (click)="cancel()">Cancel</button>
    <button mat-raised-button color="primary" type="button" [disabled]="!canSend" (click)="send()">
        <mat-spinner *ngIf="sending" diameter="16" mode="indeterminate"></mat-spinner>
        <span *ngIf="!sending">Send</span>
    </button>
</mat-dialog-actions>
